import { Component, OnInit } from '@angular/core';
import { RouterPathService } from "../../../core/common/variables/router-path.service";
import { ImagePathService } from "../../../core/common/variables/image-path.service";
import { TranslateService } from "../../common/variables/translate-service";
import { Router, RouterLink, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sen-app-main-menu-bar',
  templateUrl: './main-menu-bar.component.html',
  styleUrls: ['./main-menu-bar.component.scss']
})
export class MainMenuBarComponent implements OnInit {
  manageProjectPath: string;
  createProjectPath: string;
  roofPlanPath: string;
  inverterPlanPath: string;
  settingsPath: string;
  navMainItems: any[];

  constructor(private routerPath: RouterPathService,
    public router: Router,
    private route: ActivatedRoute,
    public imagePath: ImagePathService,
    public translate: TranslateService) {
    this.manageProjectPath = this.routerPath.manageProjectPath;
    this.createProjectPath = this.routerPath.createProjcetPath;
    this.roofPlanPath = this.routerPath.roofPlanPath;
    this.inverterPlanPath = this.routerPath.inverterPlanPath;
    this.settingsPath = this.routerPath.settingsPath;

    this.navMainItems = [
      { link: this.manageProjectPath, image: this.imagePath.manageIcon, label: 'MANAGE' },
      { link: this.createProjectPath, image: this.imagePath.projectIcon, label: 'PROJECT' },
      { link: this.roofPlanPath, image: this.imagePath.planIcon, label: 'PLAN' },
      { link: this.inverterPlanPath, image: this.imagePath.inverterIcon, label: 'PAR_GEN' },
    ]
  }

  ngOnInit(): void {
  }

  //only manage project link is active when user present in other module it will redirect to manage project path
  navigateToMPPath(link: string) {
    if (!this.router.url.includes(this.routerPath.manageProjectString)) {
      this.router.navigate([link]);
    }
  }

  navigateToSetting() {
    if (this.router.url.includes(this.routerPath.manageProjectString)) {
      this.router.navigate([this.settingsPath]);
    }
  }
}
